export const CLEAR_CART = "CLEAR_CART";
export const SET_CART_URL = "SET_CART_URL";
export const ADD_RATES_TO_CART = "ADD_RATES_TO_CART";
export const SET_CART_REQUIRED_FIELDS = "SET_CART_REQUIRED_FIELDS";
